import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ContentBlock } from 'src/app/content-blocks/models/content-block';
import { ContentBlockLayout, IContentBlockControl } from '../../models/content-block-control';
import { ContentBlockTypes } from '../../models/content-block-types';

@Component({
  selector: 'app-content-blocks',
  templateUrl: './content-blocks.component.html',
  styleUrls: ['./content-blocks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ContentBlocksComponent implements OnInit, IContentBlockControl {
  @Input()
  public get contentBlocks(): ContentBlock[] {
    return this._contentBlocks
      .filter((block) => this.include.length ? this.include.includes(block.type) : true)
      .filter((block) => this.exclude.length ? !this.exclude.includes(block.type) : true);
  }
  public set contentBlocks(value: ContentBlock[]) {
    this._contentBlocks = value;
  }
  private _contentBlocks: ContentBlock[] = [];

  @Input()
  layout = ContentBlockLayout.Normal;

  @Input()
  include: ContentBlockTypes[] = [];

  @Input()
  exclude: ContentBlockTypes[] = [];

  constructor() { }

  ngOnInit() {
  }

}
